import { Component, inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { faX, faFlag } from '@fortawesome/pro-regular-svg-icons';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'app-modal-image-landing',
  templateUrl: './modal-image-landing.component.html',
  styleUrls: ['./modal-image-landing.component.scss'],
  imports: [FontAwesomeModule],
  standalone: true
})
export class ModalImageLandingComponent {
  private modalService = inject(NgbModal);
  img: any;

  constructor(private icon: FaIconLibrary) {
    icon.addIcons(faX, faCircle, faFlag);
  }

  closeModal() {
    this.modalService.dismissAll();
  }
}
